import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";
import TransactionStatus from '../../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class IsExcludedFrom extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    inputAddress: null,
    isExcludedDataKey: null,
  };

  componentDidMount() {
    
  }

  componentDidUpdate() {
    
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    const { drizzle } = this.props;
    const { GAMEFOREST } = drizzle.contracts;
    
    const isExcludedDataKey = GAMEFOREST.methods[this.props.methodName]
            .cacheCall(this.state.inputAddress);
    this.setState({ isExcludedDataKey: isExcludedDataKey });
  }

  myChangeHandler = (event) => {
    var inputAddress = event.target.value;
    this.setState({inputAddress: inputAddress});
  }

  // destructure drizzle and drizzleState from props
  render() {

    // get the contract state from drizzleState
    var isExcluded = '0';
    const { GAMEFOREST } = this.props.drizzleState.contracts;
    var isExcludedFromTaxContract = undefined;
    if(this.state.isExcludedDataKey != null) {
      isExcludedFromTaxContract = GAMEFOREST[this.props.methodName][this.state.isExcludedDataKey];
    }
    if(isExcludedFromTaxContract == undefined) {
      isExcluded = <div>Loading</div>;
    }
    else {
      isExcluded = isExcludedFromTaxContract.value ? "yes" : "no";
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        Address:<br/>
        <input
        onChange={this.myChangeHandler}
        />
        <br/>
        <input
        type='submit'
        value="Submit"
        />
        <br/>
        {isExcluded}
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default IsExcludedFrom;
